export const gccCountries = [
    'Saudi Arabia',
    'Bahrain',
    'Kuwait',
    'Qatar',
    'Oman',
    'United Arab Emirates',
];

export function orderGcc(...comparable) {

    const GCC = [].concat(gccCountries).reverse();
    const [left, right] = comparable.map(compares => GCC.findIndex((elem) => elem === compares));

    return left < right;
}



// WEBPACK FOOTER //
// ./src/app/helpers/gcc-countries.js